import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { currencyFormatter } from "@common/helpers/currency";
import { getTotalBalance } from "@hooks/useFinancialAccounts";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { FinancialAccountBalance } from "@components/financialAccount/FinancialAccountBalance";
import { getEntityAccounts } from "../accountsView.helpers";
import { AccountsTableRow } from "../accountsView.types";
import styles from "../accountsView.module.scss";

export const BalanceCell = memo(
    ({ row }: CellContext<ViewTableFeatures, AccountsTableRow, unknown>) => {
        const rowData = row.original;
        if (!rowData.account) {
            return (
                <ViewTableCell>
                    <div className={styles.entityBalance}>
                        {currencyFormatter.format(
                            getTotalBalance(getEntityAccounts(rowData)),
                        )}
                    </div>
                </ViewTableCell>
            );
        }

        return (
            <ViewTableCell>
                <div data-testid="account-balance">
                    <FinancialAccountBalance account={rowData.account} />
                </div>
            </ViewTableCell>
        );
    },
);

BalanceCell.displayName = "BalanceCell";
